import { Alert, Snackbar, styled } from '@mui/material';

export const AlertStyled = styled(Alert)(({ theme }) => ({
  color: theme.palette.common.white,
  maxWidth: '33rem',
  alignItems: 'center',
  '&.MuiAlert-filledSuccess': {
    backgroundColor: theme.palette.green.main,
    color: theme.palette.primary.dark,
  },
  '&.MuiAlert-filledWarning': {
    backgroundColor: theme.palette.orange.main,
    color: theme.palette.primary.dark,
  },
}));

export const SnackBarStyled = styled(Snackbar)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    margin: '0rem',
  },
  margin: '1.25rem 1.5rem 0rem 1.5rem',
}));
